import { createSelector } from 'reselect';
import moment from 'moment';
import prop from 'ramda/es/prop';
import getNumEnding from 'app/common/lib/getNumEnding';


const circleLen = 151;

const periodSelector = createSelector(
  [
    (state, props) => (props.subId && state.apps.subs[props.subId]) || {},
    (_, { showSmsPrepayd }) => showSmsPrepayd,
  ],
  (sub, showSmsPrepayd) => {
    const keyStart = showSmsPrepayd ? 'sms_prepaid_start_at' : 'prepaid_start_at';
    const keyStop = showSmsPrepayd ? 'sms_prepaid_stop_at' : 'prepaid_stop_at';
    const mBegin = moment(prop(keyStart, sub) || null);
    const mEnd = moment(prop(keyStop, sub) || null);
    return ({
      daysTotal: (mBegin.isValid() && mEnd.isValid()) ? mEnd.clone().diff(mBegin, 'days') : null,
      daysLeft: (mEnd.isValid()
        ? Math.floor(moment.duration(mEnd.clone().diff(moment().clone())).clone().asDays())
        : null),
      paymentTo: mEnd.isValid() ? mEnd.format('DD.MM.YYYY') : null,
    });
  }
);

const makeIndicatorInstance = () => createSelector(
  [
    (state, props) => (props.subId && state.apps.subs[props.subId]) || {},
    periodSelector,
    (_, { t }) => t,
  ],
  (sub, period, t) => {
    const rad = (
      period.daysTotal
        && (period.daysLeft > 0)
        && parseInt(period.daysLeft * (circleLen / period.daysTotal), 10)
    ) || 0;

    return ({
      isPaid: true,
      isFree: sub.test_days_left > 0,
      circleLen,
      arcOffset: rad < circleLen ? (circleLen - rad) : circleLen,
      units: getNumEnding(
        period.daysLeft,
        [t('day'), t('day', { context: '2' }), t('day', { context: '5' })]
      ),
      daysLeft: period.daysLeft,
      paymentTo: period.paymentTo,
    });
  }
);

export default makeIndicatorInstance;
